import React from 'react';
import Events from '../components/Events';
import CatholicFeastsCalendar from '../components/CatholicFeastsCalendar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const EventsPage = () => {
   const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);
      const openContactModal = () => setIsContactModalOpen(true);
    const closeContactModal = () => setIsContactModalOpen(false);
  return (
    <div className="events-page min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header openContactModal={openContactModal} />
         {/* Modal de contact */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal} 
      />

      {/* En-tête de la page */}
      <div className="bg-gradient-to-r from-fsf-primary to-fsf-secondary py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Événements FSF
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-justify">
            Rejoignez-nous lors de nos célébrations, pèlerinages, formations et activités communautaires. 
            Consultez également le calendrier des fêtes catholiques.
          </p>
        </div>
      </div>
      
      {/* Section Événements */}
      <section id="evenements" className="py-8">
        <Events />
      </section>
      
      {/* Section Calendrier des fêtes */}
      <section id="calendrier" className="py-8">
        <CatholicFeastsCalendar />
      </section>
      <Footer />
    </div>
  );
};

export default EventsPage;